var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-sessions-list',{attrs:{"sessions":_vm.allSessions,"is-loading":_vm.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }